import { i18n } from '@lingui/core';
import { defaultAdImage } from '../utils/defaultImages';
import { t } from '../../locales/texts';

type Props = {
    img: string | undefined;
    className?: string;
};
const altText = (img: string | undefined) =>
    img ? i18n._(t.adImage.alt) : i18n._(t.adImage.defaultImgAlt);

const AdImage = ({ img, className }: Props) => (
    <img alt={altText(img)} src={img || defaultAdImage} className={className} />
);

export default AdImage;
